var module = angular.module('octopusApp.accounts');

module.directive('accountSelector', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            endpoint: '=',
            type: '@',
            usage: '='
        },
        templateUrl: 'areas/accounts/views/account_selector.html',
        controller: function ($scope, octopusRepository, busy) {
            $scope.isLoadingAccounts = busy.create();
            $scope.accounts = [];
            $scope.refresh = refresh;
            $scope.something = {};
            $scope.warning = "";

            if (!$scope.usage) {
                $scope.usage = "the connection";
            }

            if($scope.type === "AzureSubscription"){
                $scope.warning = "Only Azure management-certificate accounts may be selected.";
            }

            if($scope.type === "AzureServicePrincipal"){
                $scope.warning = "Only Azure service principal accounts may be selected.";
            }

            function getAccountById() {
                return $scope.accounts.filter(function (acc) {
                    return acc.Id === $scope.endpoint.AccountId;
                })[0];
            }

            $scope.$watch(function () {
                return $scope.accounts;
            }, function () {
                $scope.something.Account = getAccountById();
            });

            $scope.$watch(function () {
                return $scope.something.Account;
            }, function (account, oldValue) {
                if (account !== oldValue) {
                    if (account) {
                        $scope.endpoint.AccountId = $scope.something.Account.Id;
                        $scope.endpoint.AccountType = $scope.something.Account.AccountType;
                    }
                    else {
                        $scope.endpoint.AccountId = null;
                        $scope.endpoint.AccountType = null;
                    }
                }
            });


            function setAccounts(accounts) {
                var types = $scope.type.split(',');
                $scope.accounts = _.filter(accounts, function (a) {
                    return _.find(types, function (type) {
                        return type === a.AccountType;
                    });
                });
            }

            function refresh() {
                $scope.isLoadingAccounts.promise(octopusRepository.Accounts.all().then(function (accounts) {
                    setAccounts(accounts);
                }));
            }

            refresh();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/accounts/directives/account_selector.js
// module id = 3573704194733316
// module chunks = 1